import React from 'react';
import Default from 'gatsby-matrix-theme/src/components/molecules/header/variants/payment/template-one-three';
import ReviewCredits from 'gatsby-matrix-theme/src/components/atoms/review-credits';

export default (props) => {
  const { page } = props;

  return (
    <>
      <Default {...props} width='130' height='130' />
      <ReviewCredits
        authors={page?.allAuthors ? page?.allAuthors : page?.author_id && [page?.author]}
        reviewer={page.reviewer_id && page?.reviewer}
        date={props?.page?.date}
        readingTime={props?.page.reading_time}
        hasAuthorBox={props?.page?.author_id}
      />
    </>
  );
};
